import { SearchCampaignItem } from 'modules/campaigns/types/SearchCampaigns';
import { Campaign } from 'services/campaign/types';

export const removeChildrenCampaignsFromParentGroupCampaign = ({
  campaignGroupId,
  campaigns
}: {
  campaignGroupId: string;
  campaigns: (Campaign | SearchCampaignItem)[];
}) => {
  const groupCampaignIndex = campaigns.findIndex(
    (campaign) => campaign?.campaignGroupId === campaignGroupId
  );

  if (groupCampaignIndex !== -1) {
    // mark the children campaigns as hidden
    const updatedCampaigns = campaigns.map((campaign) => {
      if (
        campaign?.campaignGroupId === campaignGroupId &&
        !campaign?.isParent
      ) {
        return {
          ...campaign,
          isHidden: true
        };
      }
      return campaign;
    });

    return updatedCampaigns;
  }

  return campaigns;
};
